import { Level } from '../../../domain/level';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import tutorialSteps from './tutorial';
import { IDialogProps } from '../../Dialog';
import { TutorialDialog } from './TutorialDialog';
import { useDialog } from '../../../hooks/useDialog';
import { useElementHighlight } from './useElementHighlight';

export const useTutorial = (level: Pick<Level, 'key'>) => {
    const [ stepIndex, setStepIndex ] = useState(level.key === 'tutorial' ? 0 : 10000);
    const { t, i18n } = useTranslation();

    const step = tutorialSteps[stepIndex] ?? null;
    const active = step !== null;

    const [ highlight, hidelight ] = useElementHighlight(step?.target?.() ?? null);

    const dialogProps: Omit<IDialogProps, 'open'> = {
        children: null,
        onClose: () => {
            setStepIndex(i => i + 1);
            hidelight();
        },
    };

    if (step) {
        const text = t(`game.tutorial.${step.key}.text`);
        const nextKey = `game.tutorial.${step.key}.next`;
        const nextLbl = i18n.exists(nextKey) ? t(nextKey) : t('continue');

        dialogProps.children = (
            <TutorialDialog continueLabel={nextLbl}>
                <p>{text}</p>
            </TutorialDialog>
        );
    }

    const [ open ] = useDialog(dialogProps);

    useEffect(() => {
        if (active) {
            setTimeout(() => {

                if (step.target) {
                    highlight();
                }
                open();

            }, 100);
        }
    }, [ active, stepIndex ]);
};
